import request from '@/utils/request';

const apiURL =
    process.env.NODE_ENV === 'production' ? `${window.location.protocol}//${window.location.hostname}:${window.location.port}` : process.env.VUE_APP_API_URL;

export const getAll2FAs = user_id => {
    return request('get', `${apiURL}/8857d175-b03f-4764-b891-876fad98734b/${user_id}/user`);
};
